import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-drtv-stats',
    templateUrl: './drtv-stats.component.html',
    styleUrls: ['./drtv-stats.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrtvStatsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
